"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = Table;
exports.TableHeader = TableHeader;
exports.TableBody = TableBody;
exports.TableRow = TableRow;
exports.TableHead = TableHead;
exports.TableCell = TableCell;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("../lib/cn");
const tooltip_1 = require("./tooltip");
function Table({ wrapperClassName, className, label, children }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, cn_1.cn)('relative w-full overflow-auto', wrapperClassName), children: (0, jsx_runtime_1.jsx)("table", { "aria-label": label, className: (0, cn_1.cn)('w-full caption-bottom text-[13px]', className), children: children }) }));
}
function TableHeader({ className, children, }) {
    return ((0, jsx_runtime_1.jsx)("thead", { className: (0, cn_1.cn)('bg-[color-mix(in_oklch,var(--muted)_40%,var(--background))] sticky top-0 z-10 [&_tr]:border-b', className), children: children }));
}
function TableBody({ className, children, }) {
    return (0, jsx_runtime_1.jsx)("tbody", { className: (0, cn_1.cn)('[&_tr:last-child]:border-0', className), children: children });
}
function TableRow({ className, children, ...rest }) {
    return ((0, jsx_runtime_1.jsx)("tr", { className: (0, cn_1.cn)('hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors', className), ...rest, children: children }));
}
/**
 * ⚠️ **`scope="col"` by default.** Without it a cell cannot be traced to its heading, which is
 * the entire reason a `<th>` differs from a `<td>`. Pass `scope="row"` for a row header.
 *
 * ⚠️ **A header is TEXT here, not a sort button.** The design system sorts from the toolbar
 * select, not from a clickable header — the header pattern does not exist in it. Rendering a
 * `<button>` in a `<th>` invents an affordance the product does not have.
 */
function TableHead({ className, children, scope = 'col', title, ...rest }) {
    /* ⚠️ `title` is the kit's tooltip, never the browser's — `Button` carries the argument. */
    const tip = (0, tooltip_1.useTooltip)(title);
    return ((0, jsx_runtime_1.jsxs)("th", { scope: scope, className: (0, cn_1.cn)('text-muted-foreground h-8 px-3 text-left align-middle text-[11px] font-medium tracking-wide whitespace-nowrap uppercase', className), ...rest, ...tip.triggerProps(rest), children: [children, tip.bubble] }));
}
/**
 * ⚠️ **`numeric` is not a style choice.** A figure in a column without `tabular-nums` shifts
 * its digits between rows, so a column of hours cannot be read down — `state-rules.md` §5 makes
 * it a rule rather than a preference. It also right-aligns, because that is what makes the
 * magnitudes line up.
 */
function TableCell({ className, children, numeric = false, title, ...rest }) {
    const tip = (0, tooltip_1.useTooltip)(title);
    return ((0, jsx_runtime_1.jsxs)("td", { className: (0, cn_1.cn)('px-3 py-1.5 align-middle whitespace-nowrap', numeric && 'text-right tabular-nums', className), ...rest, ...tip.triggerProps(rest), children: [children, tip.bubble] }));
}
//# sourceMappingURL=table.js.map